import { EnumMessageRole } from '../enums/message-role.enum';
import { IChatMessage } from '../interfaces/chat-message.interface';
import { attachmentKey } from '../interfaces/message-attachment.interface';

const unionBy = <T>(
  server: T[] = [],
  local: T[] = [],
  identity: (value: T) => string
): T[] => {
  const values = new Map(server.map((value) => [identity(value), value]));
  local.forEach((value) => {
    if (!values.has(identity(value))) {
      values.set(identity(value), value);
    }
  });
  return [...values.values()];
};

/** O histórico pode estar atrasado em relação ao stream; recuperar não deve apagar conteúdo recebido. */
export const reconcileMessages = (
  server: IChatMessage[],
  local: IChatMessage[]
): IChatMessage[] => {
  const result = [...server];
  const matched = new Set<number>();
  const pending: IChatMessage[] = [];
  for (const message of [...local].reverse()) {
    let index = message.id
      ? server.findIndex((item) => item.id === message.id)
      : -1;
    // O histórico ainda não expõe client_message_id. Pareia ocorrências, preservando repetições legítimas.
    if (!message.id && message.role === EnumMessageRole.USER) {
      for (let candidate = server.length - 1; candidate >= 0; candidate--) {
        const item = server[candidate];
        if (
          !matched.has(candidate) &&
          item.role === message.role &&
          item.content === message.content &&
          item.quickActionTitle === message.quickActionTitle &&
          JSON.stringify(
            item.references?.map((reference) => reference.id) || []
          ) ===
            JSON.stringify(
              message.references?.map((reference) => reference.id) || []
            )
        ) {
          index = candidate;
          break;
        }
      }
    }
    if (index < 0) {
      if (
        message.role === EnumMessageRole.USER ||
        message.content ||
        message.attachments?.length ||
        message.charts?.length
      ) {
        pending.unshift(message);
      }
      continue;
    }
    matched.add(index);
    const canonical = result[index];
    const preserveText =
      message.content.length > canonical.content.length &&
      message.content.startsWith(canonical.content);
    result[index] = {
      ...canonical,
      localId: message.localId,
      ...(preserveText && {
        content: message.content,
        htmlContent: message.htmlContent
      }),
      references: unionBy(
        canonical.references,
        message.references,
        (reference) => reference.id
      ),
      attachments: unionBy(
        canonical.attachments,
        message.attachments,
        attachmentKey
      ),
      charts: unionBy(canonical.charts, message.charts, (chart) =>
        JSON.stringify(chart)
      )
    };
  }
  return [...result, ...pending];
};
